import React from 'react';
import RawHtml from '../Editors/RawHtml/raw-html';
import '../styles/DetailTable.sass';

export const FoBasicInformation = ({ dataToRender }) => {
  return (
    <table className="table table-striped detail-info-table">
      <tbody>
        {dataToRender.map(({ label, value, isRaw = false }, index) => (
          <tr key={index}>
            <td>
              <b>{label}</b>
            </td>
            <td>{isRaw ? <RawHtml>{value}</RawHtml> : value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
